
import React from "react";
import { TableHead, TableRow, TableHeader } from "@/components/ui/table";
import { ArrowUp, ArrowDown } from "lucide-react";

interface WorksheetTableHeaderProps {
  sortField: string;
  sortDirection: "asc" | "desc";
  handleSort: (field: string) => void;
}

export const WorksheetTableHeader: React.FC<WorksheetTableHeaderProps> = ({
  sortField,
  sortDirection,
  handleSort
}) => {
  const SortableTableHead: React.FC<{ field: string; label: string }> = ({ field, label }) => (
    <TableHead 
      className="cursor-pointer hover:bg-gray-100"
      onClick={() => handleSort(field)}
    >
      <div className="flex items-center gap-1">
        {label}
        {sortField === field && (sortDirection === "asc" ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />)}
      </div>
    </TableHead>
  );

  return (
    <TableHeader>
      <TableRow>
        <SortableTableHead field="id" label="ID" />
        <SortableTableHead field="name" label="ชื่อชีท" />
        <SortableTableHead field="subject" label="วิชา" />
        <SortableTableHead field="grade_level" label="ระดับชั้น" />
        <TableHead>เทอม</TableHead>
        <TableHead>เอกสาร</TableHead>
        <SortableTableHead field="created_at" label="วันที่สร้าง" />
        <TableHead className="text-right">จัดการ</TableHead>
      </TableRow>
    </TableHeader>
  );
};
